import React from "react";

import { useCopies } from "shared/hooks/useCopies";
import { ConfirmationTopNotificationPropTypes } from "./types";

function ConfirmationTopNotification(props: ConfirmationTopNotificationPropTypes) {
  const copies = useCopies();

  return (
    <React.Fragment>
      <p className="purchaseConfirm_msgDetails--text">{props.isBTA ? props.btaCopy : props.userCopy}</p>
      {props.helpdeskEmail && (
        <p
          className="purchaseConfirm_msgDetails--text"
          dangerouslySetInnerHTML={{
            __html: copies.get("email.support.with.questions", {
              0: `<strong class="purchaseConfirm_msgDetails--helpdesk">${props.helpdeskEmail}</strong>`
            })
          }}
        />
      )}
    </React.Fragment>
  );
}

export default ConfirmationTopNotification;
